import TrendingVideoPost from './TrendingVideoPost'

export default TrendingVideoPost
